import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import type { Unit } from "~/api/units";
import { ROUTES } from "~/router";
import { Button, Card } from "~/ui";

interface UnitCardProps {
  unit: Unit;
}

export const UnitCard = ({ unit }: UnitCardProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Card className="flex w-full flex-row">
      <div className="flex grow flex-col gap-2">
        <h3 className="text-lg font-semibold text-primary-50 dark:text-primary-80">
          {unit.name}
        </h3>
        <p className="font-medium text-neutral-60 dark:text-tertiary">
          {unit.location}
        </p>
      </div>
      <Button
        className="h-fit self-center"
        text={t("units.view_unit")}
        variant="outline"
        color="primary"
        size="sm"
        aria-label={t("unit_detail.view_unit", { unitName: unit.name })}
        onClick={() =>
          navigate(ROUTES.unitDetail.replace(":id", unit.id.toString()))
        }
      />
    </Card>
  );
};
